import { memo } from 'react'

import { useTranslation } from 'react-i18next'

import { Header } from '@shared/components/Header'
import { Content } from '@shared/layouts'

const StructureRaw = () => {
  const { t } = useTranslation(['entity'])

  return <Content HeaderSlot={<Header title={t('entity:publishing.space', { count: 2 })} disabled />} />
}

export const Structure = memo(StructureRaw)
